<template>
    <div>
        <div id="content-form">
            <v-container fluid>
                <v-row>
                    <v-col cols="12" sm="4" md="3" lg="2" class="nav-left pa-0 d-none d-sm-block">
                        <SideMenu />
                    </v-col>
                    <v-col cols="12" sm="8" md="9" lg="10" class="nav-right px-0 pl-sm-14">
                        <!-- <v-parallax height="auto" src="" class="px-0"> -->
                        <div class="stepper py-5 px-10">
                            <v-container class="ma-auto" v-if="!noStepper">
                                <v-row>
                                    <v-col cols="6">
                                        <p class="pa-6 active">PASO 1: ACTUALIZAR PERFIL</p>
                                    </v-col>
                                    <v-col cols="6">
                                        <p class="pa-6">PASO 2: RESPONDER PREGUNTAS Y POSTULAR</p>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </div>
                        <div class="webform">
                            <v-form ref="form" lazy-validation>
                                <v-row class="pa-0">
                                    <v-col cols="12" class="pa-0">
                                        <v-card ref="form" color="transparent" class="form-card">
                                            <div class="text-left">
                                                <v-container class="mx-0">
                                                    <v-row
                                                        align="center"
                                                        class="text-center text-sm-left"
                                                    >
                                                        <v-col
                                                            cols="12"
                                                            sm="6"
                                                            md="6"
                                                            lg="8"
                                                            class="px-5"
                                                        >
                                                            <h3>Mi Perfil</h3>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="6" lg="4">
                                                            <v-row>
                                                                <v-col cols="12" sm="6" md="6">
                                                                    <v-btn
                                                                        color="info"
                                                                        large
                                                                        button
                                                                        @click="updateProfile"
                                                                        class="d-block btn-form"
                                                                        :disabled="
                                                                            $v.candidate.$invalid ||
                                                                                $v.textValidate
                                                                                    .$invalid ||
                                                                                loading ||
                                                                                candidateResumeErrors.length !==
                                                                                    0
                                                                        "
                                                                        >GUARDAR</v-btn
                                                                    >
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="mr-0">
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="py-2 px-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Imagen de Perfil
                                                            </h4>
                                                            <v-tooltip right>
                                                                <template
                                                                    v-slot:activator="{ on, attrs }"
                                                                >
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        class="info-help"
                                                                        >mdi-information</v-icon
                                                                    >
                                                                </template>
                                                                <span class="tooltip-txt"
                                                                    >Elige una imagen para tu
                                                                    perfil. Recuerda que es la que
                                                                    verán las Organizaciones cuando
                                                                    postules. Si prefieres no
                                                                    hacerlo, aparecerán tus
                                                                    iniciales.</span
                                                                >
                                                            </v-tooltip>
                                                            <ImageLoader
                                                                id="img-profile"
                                                                ref="imgProfile"
                                                                cols="10"
                                                                class="col-12 col-sm-8 col-md-8 col-lg-6 pa-0"
                                                                default="@/assets/images/logo-default.webp"
                                                                path="uploads/images/logos/"
                                                                v-model="candidate.avatar"
                                                                @img-load="onImgLoad"
                                                            />
                                                            <p class="text--disabled">
                                                                Sube una foto para mostrar <br />
                                                                en la miniatura de tu perfil
                                                            </p>
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="py-2 px-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Nombre
                                                            </h4>
                                                            <v-col cols="12" class="ma-0 pa-0">
                                                                <v-text-field
                                                                    name="firstName"
                                                                    placeholder=""
                                                                    hint="Obligatorio"
                                                                    persistent-hint
                                                                    v-model="candidate.firstName"
                                                                    :error-messages="
                                                                        candidateFirstNameErrors
                                                                    "
                                                                    @input="
                                                                        $v.candidate.firstName.$touch()
                                                                    "
                                                                    @blur="
                                                                        $v.candidate.firstName.$touch()
                                                                    "
                                                                />
                                                            </v-col>
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="py-2 px-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Apellidos
                                                            </h4>
                                                            <v-col cols="12" class="ma-0 pa-0">
                                                                <v-text-field
                                                                    name="lastName"
                                                                    placeholder=""
                                                                    hint="Obligatorio"
                                                                    persistent-hint
                                                                    v-model="candidate.lastName"
                                                                    :error-messages="
                                                                        candidateLastNameErrors
                                                                    "
                                                                    @input="
                                                                        $v.candidate.lastName.$touch()
                                                                    "
                                                                    @blur="
                                                                        $v.candidate.lastName.$touch()
                                                                    "
                                                                />
                                                            </v-col>
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="py-2 px-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Teléfono
                                                            </h4>
                                                            <!-- <v-tooltip right>
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" class="info-help">mdi-information</v-icon>
                                  </template>
                                  <span class="tooltip-txt">No tengo el texto aún</span>
                                </v-tooltip> -->
                                                            <v-col cols="12" class="ma-0 pa-0">
                                                                <v-text-field
                                                                    name="phone"
                                                                    placeholder=""
                                                                    hint="Opcional"
                                                                    persistent-hint
                                                                    v-model="candidate.phone"
                                                                    :error-messages="
                                                                        candidatePhoneErrors
                                                                    "
                                                                    @input="
                                                                        $v.candidate.phone.$touch()
                                                                    "
                                                                    @blur="
                                                                        $v.candidate.phone.$touch()
                                                                    "
                                                                />
                                                            </v-col>
                                                            <!-- <p class="text--disabled">Por favor indica el número de años que llevas en el mercado laboral</p> -->
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="py-2 px-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Ciudad
                                                            </h4>
                                                            <v-tooltip right>
                                                                <template
                                                                    v-slot:activator="{ on, attrs }"
                                                                >
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        class="info-help"
                                                                        >mdi-information</v-icon
                                                                    >
                                                                </template>
                                                                <span class="tooltip-txt"
                                                                    >Selecciona la ciudad en la que
                                                                    vives actualmente.</span
                                                                >
                                                            </v-tooltip>
                                                            <v-select
                                                                ref="candidateCity"
                                                                name="candidateCity"
                                                                placeholder="Selecciona la ciudad"
                                                                hint="Obligatorio"
                                                                persistent-hint
                                                                v-model="candidate.city"
                                                                :items="getCities"
                                                                required
                                                                :error-messages="
                                                                    candidateCityErrors
                                                                "
                                                                @input="$v.candidate.city.$touch()"
                                                                @blur="$v.candidate.city.$touch()"
                                                                cols="4"
                                                                md="4"
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="py-2 px-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Fecha de Nacimiento
                                                            </h4>
                                                            <v-tooltip right>
                                                                <template
                                                                    v-slot:activator="{ on, attrs }"
                                                                >
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        class="info-help"
                                                                        >mdi-information</v-icon
                                                                    >
                                                                </template>
                                                                <span class="tooltip-txt">
                                                                    Indica tu fecha de nacimiento.
                                                                    Esta información es referencial,
                                                                    pero no es obligatoria ni
                                                                    excluyente en las postulaciones.
                                                                </span>
                                                            </v-tooltip>
                                                            <DatePicker
                                                                v-model="birthDate"
                                                                :min="getMin"
                                                                :max="getMax"
                                                                placeholder="día/mes/año"
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            class="blue lighten-5 ma-1"
                                                        >
                                                            <v-col cols="11" sm="10" md="10">
                                                                <h4 class="d-inline-block mr-2">
                                                                    Acerca de ti y tu propósito
                                                                </h4>
                                                                <v-tooltip right>
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            class="info-help"
                                                                        >
                                                                            mdi-information
                                                                        </v-icon>
                                                                    </template>
                                                                    <span class="tooltip-txt">
                                                                        Describe brevemente tu
                                                                        trayectoria profesional,
                                                                        mediante logros alcanzados o
                                                                        un relato de lo que has
                                                                        hecho. Es importante que
                                                                        describas tu propósito
                                                                        laboral (qué te moviliza y
                                                                        cuál es el sentido que tiene
                                                                        para ti el trabajo). Esto
                                                                        ayudará a que encuentres
                                                                        trabajos que se ajusten a tu
                                                                        perfil.
                                                                    </span>
                                                                </v-tooltip>
                                                                <tiptap-vuetify
                                                                    ref="candidatePurpose"
                                                                    name="candidatePurpose"
                                                                    v-model="candidate.purpose"
                                                                    placeholder="Escribe aquí acerca de ti y tu propósito"
                                                                    :extensions="extensions"
                                                                    counter="1000"
                                                                    required
                                                                    :error-messages="
                                                                        candidatePurposeErrors
                                                                    "
                                                                    @input="
                                                                        $v.textValidate.purpose.$touch()
                                                                    "
                                                                    @blur="
                                                                        $v.textValidate.purpose.$touch()
                                                                    "
                                                                >
                                                                </tiptap-vuetify>
                                                                <div class="v-text-field__details">
                                                                    <div
                                                                        class="v-messages theme--light"
                                                                    >
                                                                        <div
                                                                            class="v-messages__wrapper d-flex justify-space-between"
                                                                        >
                                                                            <div
                                                                                :class="
                                                                                    `v-messages__message ${
                                                                                        candidatePurposeErrors.length !==
                                                                                        0
                                                                                            ? 'red--text'
                                                                                            : ''
                                                                                    }`
                                                                                "
                                                                            >
                                                                                Obligatorio
                                                                            </div>
                                                                            <span
                                                                                >{{
                                                                                    getInnerText(
                                                                                        candidate.purpose
                                                                                    ).length
                                                                                }}/1000</span
                                                                            >
                                                                        </div>
                                                                        <div
                                                                            :class="
                                                                                `v-messages__message ${
                                                                                    candidatePurposeErrors.length !==
                                                                                    0
                                                                                        ? 'red--text'
                                                                                        : ''
                                                                                }`
                                                                            "
                                                                        >
                                                                            <span
                                                                                v-for="(item,
                                                                                index) in candidatePurposeErrors"
                                                                                :key="index"
                                                                                >{{ item }}</span
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </v-col>
                                                            <v-col cols="11" sm="10" md="10">
                                                                <h4 class="d-inline-block mr-2">
                                                                    Profesión
                                                                </h4>
                                                                <v-tooltip right>
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            class="info-help"
                                                                            >mdi-information</v-icon
                                                                        >
                                                                    </template>
                                                                    <span class="tooltip-txt"
                                                                        >Selecciona tu profesión(es.
                                                                        Puedes marcar más de
                                                                        una.</span
                                                                    >
                                                                </v-tooltip>
                                                                <v-select
                                                                    ref="professions"
                                                                    name="professions"
                                                                    placeholder="Selecciona tu(s) profesión(es)"
                                                                    hint="Obligatorio"
                                                                    persistent-hint
                                                                    v-model="candidate.professions"
                                                                    :error-messages="
                                                                        candidateProfessionsErrors
                                                                    "
                                                                    :items="getProfessions"
                                                                    @input="
                                                                        $v.candidate.professions.$touch()
                                                                    "
                                                                    @blur="
                                                                        $v.candidate.professions.$touch()
                                                                    "
                                                                    multiple
                                                                    chips
                                                                />
                                                            </v-col>
                                                            <v-col
                                                                cols="11"
                                                                sm="10"
                                                                md="7"
                                                                class="pa-2"
                                                            >
                                                                <h4 class="d-inline-block mr-2">
                                                                    Nivel Educacional
                                                                </h4>
                                                                <v-tooltip right>
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            class="info-help"
                                                                            >mdi-information</v-icon
                                                                        >
                                                                    </template>
                                                                    <span class="tooltip-txt"
                                                                        >Por favor seleccionar el
                                                                        último nivel educacional
                                                                        alcanzado.</span
                                                                    >
                                                                </v-tooltip>
                                                                <v-select
                                                                    ref="degree"
                                                                    name="degree"
                                                                    hint="Obligatorio"
                                                                    persistent-hint
                                                                    placeholder="Selecciona tu ultimo nivel de formacion academica"
                                                                    v-model="candidate.degree"
                                                                    :error-messages="
                                                                        candidateDegreeErrors
                                                                    "
                                                                    :items="getDegree"
                                                                    @input="
                                                                        $v.candidate.degree.$touch()
                                                                    "
                                                                    @blur="
                                                                        $v.candidate.degree.$touch()
                                                                    "
                                                                />
                                                            </v-col>
                                                            <v-col cols="11" sm="10" md="10">
                                                                <h4 class="d-inline-block mr-2">
                                                                    Áreas de conocimiento
                                                                </h4>
                                                                <v-tooltip right>
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            class="info-help"
                                                                            >mdi-information</v-icon
                                                                        >
                                                                    </template>
                                                                    <span class="tooltip-txt"
                                                                        >Selecciona las áreas de
                                                                        conocimiento que has
                                                                        adquirido a lo largo de tu
                                                                        trayectoria profesional.
                                                                        Creemos que las personas
                                                                        aprenden mucho de la
                                                                        experiencia, por lo que esta
                                                                        es tu oportunidad para
                                                                        contarles que más sabes
                                                                        hacer.</span
                                                                    >
                                                                </v-tooltip>
                                                                <v-select
                                                                    ref="candidateKnowledgeAreas"
                                                                    name="candidateKnowledgeAreas"
                                                                    hint="Puedes seleccionar hasta 5"
                                                                    persistent-hint
                                                                    placeholder="Puedes seleccionar hasta 5"
                                                                    v-model="
                                                                        candidate.knowledgeAreas
                                                                    "
                                                                    :error-messages="
                                                                        candidateKnowledgeErrors
                                                                    "
                                                                    :items="getAreas"
                                                                    @input="
                                                                        $v.candidate.knowledgeAreas.$touch()
                                                                    "
                                                                    @blur="
                                                                        $v.candidate.knowledgeAreas.$touch()
                                                                    "
                                                                    multiple
                                                                    chips
                                                                />
                                                            </v-col>
                                                            <v-col
                                                                cols="11"
                                                                sm="10"
                                                                md="7"
                                                                class="pa-2"
                                                            >
                                                                <h4 class="d-inline-block mr-2">
                                                                    Años de Experiencia
                                                                </h4>
                                                                <v-tooltip right>
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            class="info-help"
                                                                            >mdi-information</v-icon
                                                                        >
                                                                    </template>
                                                                    <span class="tooltip-txt"
                                                                        >Indica el número de años
                                                                        que llevas trabajando</span
                                                                    >
                                                                </v-tooltip>
                                                                <v-col cols="4" class="ma-0 pa-0">
                                                                    <v-text-field
                                                                        name="experience"
                                                                        placeholder="Por favor indica el número de años que llevas en el mercado laboral"
                                                                        hint="Obligatorio"
                                                                        persistent-hint
                                                                        v-model="
                                                                            candidate.experience
                                                                        "
                                                                        :error-messages="
                                                                            candidateExperienceErrors
                                                                        "
                                                                        @input="
                                                                            $v.candidate.experience.$touch()
                                                                        "
                                                                        @blur="
                                                                            $v.candidate.experience.$touch()
                                                                        "
                                                                    />
                                                                </v-col>
                                                                <!-- <p class="text--disabled">Por favor indica el número de años que llevas en el mercado laboral</p> -->
                                                            </v-col>

                                                            <!-- Se oculta Experiencia por "inestabilidad" -->
                                                            <v-col
                                                                cols="11"
                                                                sm="10"
                                                                md="10"
                                                                v-if="false"
                                                            >
                                                                <h4 class="d-inline-block mr-2">
                                                                    Experiencia Laboral
                                                                </h4>
                                                                <v-tooltip right>
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <v-icon
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            class="info-help"
                                                                            >mdi-information</v-icon
                                                                        >
                                                                    </template>
                                                                    <span class="tooltip-txt"
                                                                        >Describe tus últimos
                                                                        trabajos, desde el más
                                                                        reciente al más antigüo:
                                                                        nombre de la empresa, cargo
                                                                        y breve descripción de tus
                                                                        responsabilidades y
                                                                        logros.</span
                                                                    >
                                                                </v-tooltip>
                                                                <p class="text--disabled">
                                                                    Describe brevemente tus últimas
                                                                    experiencias laborales
                                                                </p>
                                                                <v-row>
                                                                    <v-chip
                                                                        v-for="(works,
                                                                        index) in candidate.userExperiences"
                                                                        :key="index"
                                                                        close
                                                                        @click:close="
                                                                            deleteExperience(
                                                                                works.id
                                                                            )
                                                                        "
                                                                        class="ma-1"
                                                                    >
                                                                        {{
                                                                            `${works.organizationName} - ${works.position}`
                                                                        }}
                                                                    </v-chip>
                                                                    <v-progress-linear
                                                                        color="primary"
                                                                        indeterminate
                                                                        v-if="expRemoveIsLoadig"
                                                                    >
                                                                    </v-progress-linear>
                                                                </v-row>
                                                                <v-row
                                                                    justify="center"
                                                                    align="center"
                                                                    v-if="experienceIsLoadig"
                                                                >
                                                                    <v-progress-circular
                                                                        size="40"
                                                                        color="primary"
                                                                        indeterminate
                                                                    >
                                                                    </v-progress-circular>
                                                                </v-row>
                                                                <v-row
                                                                    justify="start"
                                                                    align="center"
                                                                    v-else
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        sm="12"
                                                                        md="12"
                                                                        class="pa-0"
                                                                    >
                                                                        <v-form
                                                                            ref="experienceForm"
                                                                        >
                                                                            <v-col
                                                                                cols="8"
                                                                                class="pa-2"
                                                                            >
                                                                                <v-combobox
                                                                                    name="organization"
                                                                                    placeholder="Nombre de la Organización"
                                                                                    hint="Obligatorio"
                                                                                    persistent-hint
                                                                                    v-model="
                                                                                        work.organization
                                                                                    "
                                                                                    :items="
                                                                                        organizations
                                                                                    "
                                                                                    item-text="name"
                                                                                    return-object
                                                                                    :error-messages="
                                                                                        orgExpRules
                                                                                    "
                                                                                    @blur="
                                                                                        $v.work.organization.$touch()
                                                                                    "
                                                                                    @input="
                                                                                        $v.work.organization.$touch()
                                                                                    "
                                                                                >
                                                                                </v-combobox>
                                                                            </v-col>
                                                                            <v-col cols="8">
                                                                                <v-text-field
                                                                                    name="position"
                                                                                    placeholder="Nombre del Cargo"
                                                                                    hint="Obligatorio"
                                                                                    persistent-hint
                                                                                    v-model="
                                                                                        work.position
                                                                                    "
                                                                                    :error-messages="
                                                                                        positionExpRules
                                                                                    "
                                                                                    @blur="
                                                                                        $v.work.position.$touch()
                                                                                    "
                                                                                    @input="
                                                                                        $v.work.position.$touch()
                                                                                    "
                                                                                />
                                                                            </v-col>
                                                                            <v-col cols="12">
                                                                                <v-textarea
                                                                                    name="brief"
                                                                                    placeholder="Breve descripción"
                                                                                    hint="Obligatorio"
                                                                                    persistent-hint
                                                                                    v-model="
                                                                                        work.brief
                                                                                    "
                                                                                    :error-messages="
                                                                                        briefExpRules
                                                                                    "
                                                                                    @blur="
                                                                                        $v.work.brief.$touch()
                                                                                    "
                                                                                    @input="
                                                                                        $v.work.brief.$touch()
                                                                                    "
                                                                                    rows="1"
                                                                                    auto-grow
                                                                                    row-height="10"
                                                                                    counter="250"
                                                                                />
                                                                            </v-col>
                                                                            <v-col cols="12">
                                                                                <v-row
                                                                                    align="center"
                                                                                >
                                                                                    <v-col
                                                                                        xl="4"
                                                                                        lg="4"
                                                                                        cols="12"
                                                                                        md="12"
                                                                                    >
                                                                                        <DatePicker
                                                                                            v-model="
                                                                                                work.startAt
                                                                                            "
                                                                                            placeholder=" Fecha inicio (dd/mm/aaaa)"
                                                                                            :max="
                                                                                                new Date()
                                                                                                    .toISOString()
                                                                                                    .substr(
                                                                                                        0,
                                                                                                        10
                                                                                                    )
                                                                                            "
                                                                                            hint="Obligatorio"
                                                                                            :error="
                                                                                                getErrorStarAtExp
                                                                                            "
                                                                                            @blur="
                                                                                                $v.work.startAt.$touch()
                                                                                            "
                                                                                            @input="
                                                                                                $v.work.startAt.$touch()
                                                                                            "
                                                                                        />
                                                                                    </v-col>
                                                                                    <v-col
                                                                                        xl="4"
                                                                                        lg="4"
                                                                                        cols="12"
                                                                                        md="12"
                                                                                    >
                                                                                        <DatePicker
                                                                                            v-model="
                                                                                                work.endAt
                                                                                            "
                                                                                            :placeholder="
                                                                                                today
                                                                                                    ? 'A la fecha'
                                                                                                    : 'Fecha termino (dd/mm/aaaa)'
                                                                                            "
                                                                                            :disabled="
                                                                                                today
                                                                                            "
                                                                                            :max="
                                                                                                new Date()
                                                                                                    .toISOString()
                                                                                                    .substr(
                                                                                                        0,
                                                                                                        10
                                                                                                    )
                                                                                            "
                                                                                        />
                                                                                    </v-col>
                                                                                    <v-col
                                                                                        xl="2"
                                                                                        lg="2"
                                                                                        cols="12"
                                                                                        md="12"
                                                                                    >
                                                                                        <v-switch
                                                                                            v-model="
                                                                                                today
                                                                                            "
                                                                                        >
                                                                                            <template
                                                                                                v-slot:label
                                                                                            >
                                                                                                <span
                                                                                                    class="switch-label"
                                                                                                >
                                                                                                    A
                                                                                                    la
                                                                                                    fecha
                                                                                                </span>
                                                                                            </template>
                                                                                        </v-switch>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-col>
                                                                        </v-form>
                                                                    </v-col>
                                                                </v-row>
                                                                <div class="text-end">
                                                                    <v-btn
                                                                        fab
                                                                        color="primary"
                                                                        @click="saveExperience"
                                                                    >
                                                                        <v-icon dark>
                                                                            mdi-plus
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </v-col>
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="pa-6"
                                                        >
                                                            <h4>
                                                                Marca a continuación los 4
                                                                principales Objetivos de Desarrollo
                                                                Sostenible (ODS) con los que te
                                                                identifiques (opcional)
                                                            </h4>
                                                            <p>
                                                                Si no sabes lo que son los Objetivos
                                                                de Desarrollo Sostenible, haz
                                                                <a
                                                                    href="https://www.pactoglobal.cl/objetivos-de-desarrollo-sostenible/conoce-los-ods/"
                                                                    target="_blank"
                                                                    >click acá</a
                                                                >
                                                            </p>
                                                            <div>
                                                                <v-row>
                                                                    <Goals
                                                                        @click="goalsSelected"
                                                                        cols="2"
                                                                        :goals="candidate.goals"
                                                                    />
                                                                </v-row>
                                                            </div>
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="pa-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Redes sociales
                                                            </h4>
                                                            <v-tooltip right>
                                                                <template
                                                                    v-slot:activator="{ on, attrs }"
                                                                >
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        class="info-help"
                                                                        >mdi-information</v-icon
                                                                    >
                                                                </template>
                                                                <span class="tooltip-txt"
                                                                    >Ingresa tus RRSS para que las
                                                                    organizaciones puedan seguirte y
                                                                    conocer más de ti.</span
                                                                >
                                                            </v-tooltip>
                                                            <v-row
                                                                class="justify-md-start justify-center"
                                                            >
                                                                <v-col
                                                                    cols="6"
                                                                    v-for="(sn, index) in networks"
                                                                    :key="index"
                                                                >
                                                                    <v-text-field
                                                                        :ref="sn.title"
                                                                        :name="sn.title"
                                                                        :placeholder="sn.title"
                                                                        v-model="
                                                                            candidate.networks[
                                                                                sn.name
                                                                            ]
                                                                        "
                                                                        :prepend-icon="
                                                                            `mdi-${sn.name}`
                                                                        "
                                                                    />
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                        <v-col
                                                            cols="11"
                                                            sm="10"
                                                            md="7"
                                                            class="py-2 px-6"
                                                        >
                                                            <h4 class="d-inline-block mr-2">
                                                                Subir tu curriculum Vitae
                                                            </h4>
                                                            <v-tooltip right>
                                                                <template
                                                                    v-slot:activator="{ on, attrs }"
                                                                >
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        class="info-help"
                                                                        >mdi-information</v-icon
                                                                    >
                                                                </template>
                                                                <span class="tooltip-txt"
                                                                    >Sube acá tu CV actualizado en
                                                                    formato PDF para que las
                                                                    Organizaciones interesadas en tu
                                                                    perfil, puedan revisalo en
                                                                    detalle.</span
                                                                >
                                                            </v-tooltip>
                                                            <v-file-input
                                                                ref="resume"
                                                                name="resume"
                                                                :placeholder="
                                                                    candidate.resume.length > 0
                                                                        ? candidate.resume
                                                                        : 'Debes subirlo en formato PDF'
                                                                "
                                                                accept=".pdf"
                                                                :error-messages="
                                                                    candidateResumeErrors
                                                                "
                                                                @change="saveResume"
                                                                hint="Obligatorio"
                                                                persistent-hint
                                                                :loading="isLoadingFile"
                                                            >
                                                                <template v-slot:selection>
                                                                    {{
                                                                        candidate.resume.length > 0
                                                                            ? candidate.resume
                                                                            : "Debes subirlo en formato PDF"
                                                                    }}
                                                                </template>
                                                                <template v-slot:append-outer>
                                                                    <v-btn
                                                                        text
                                                                        @click="getCV"
                                                                        color="blue"
                                                                        elevation="3"
                                                                        fab
                                                                        small
                                                                        v-if="
                                                                            candidate.resume
                                                                                .length > 0 ||
                                                                                candidate.resume !==
                                                                                    ''
                                                                        "
                                                                    >
                                                                        <v-icon>
                                                                            mdi-file-download-outline
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                            </v-file-input>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </div>
                                            <div v-if="errors.length" class="error-form px-10">
                                                <p>Favor corregir los siguientes errores:</p>
                                                <ul>
                                                    <li v-for="error in errors" v-bind:key="error">
                                                        {{ error }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <v-card-actions class="text-center px-10">
                                                <v-row class="justify-md-start justify-center">
                                                    <v-col cols="12" sm="7" md="4" lg="3">
                                                        <v-btn
                                                            color="info"
                                                            button
                                                            outlined
                                                            large
                                                            @click="previewForm"
                                                            class="d-block btn-form"
                                                        >
                                                            PREVISUALIZAR PERFIL
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" sm="5" md="4" lg="3">
                                                        <v-btn
                                                            color="info"
                                                            large
                                                            button
                                                            @click="updateProfile"
                                                            :loading="loading"
                                                            :disabled="
                                                                $v.candidate.$invalid ||
                                                                    $v.textValidate.$invalid ||
                                                                    loading ||
                                                                    candidateResumeErrors.length !==
                                                                        0
                                                            "
                                                            class="d-block btn-form"
                                                        >
                                                            GUARDAR
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-card-actions>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </div>
                        <!-- </v-parallax> -->
                    </v-col>
                </v-row>
            </v-container>
        </div>

        <CandidateDialog
            :key="dialogKey"
            :dialog="dialog"
            :candidate="{ user: candidate }"
            @close="value => (dialog = value)"
        />
        <Footer />
    </div>
</template>

<script>
import ImageLoader from "@/components/ImageLoader";
import Goals from "@/components/Goals";
import DatePicker from "@/components/DatePicker";
import SideMenu from "@/components/SideMenu";
import CandidateDialog from "@/components/CandidateDialog";
import { fixturesComputed, userComputed } from "@/store/helpers.js";
import { validationMixin } from "vuelidate";
import {
    TiptapVuetify,
    Bold,
    Italic,
    Underline,
    BulletList,
    OrderedList,
    ListItem,
    Link,
    History
} from "tiptap-vuetify";
import { required, minLength, maxLength, numeric, integer } from "vuelidate/lib/validators";
import { handleTxt, meta } from "@/libs/mixins";

export default {
    name: "CandidateProfile",

    mixins: [validationMixin, handleTxt, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Mi perfil"
        });
    },

    props: ["noStepper"],

    validations: {
        work: {
            startAt: { required },
            brief: { required, maxLength: maxLength(250) },
            position: { required },
            organization: { required }
        },
        resume: {},
        candidate: {
            firstName: { required },
            lastName: { required },
            phone: { numeric, integer, maxLength: maxLength(12) },
            city: { required },
            knowledgeAreas: { maxLength: maxLength(5) },
            professions: { required },
            degree: { required },
            experience: { required, numeric, integer },
            resume: { required },
            userExperiences: {}
        },
        textValidate: {
            purpose: { required, minLength: minLength(200), maxLength: maxLength(1000) }
        }
    },

    components: {
        ImageLoader,
        Goals,
        DatePicker,
        SideMenu,
        TiptapVuetify,
        CandidateDialog
    },

    data() {
        return {
            expRemoveIsLoadig: false,
            experienceIsLoadig: false,
            today: true,
            organizations: [],
            tags: "",
            isLoadingFile: false,
            birthDate: "",
            menuDate: false,
            dialog: false,
            dialogKey: new Date().getTime(),
            textValidate: {
                purpose: ""
            },
            candidate: {
                firstName: "",
                lastName: "",
                avatar: null,
                birthAt: "",
                phone: "",
                city: "",
                degree: "",
                resume: "",
                goals: [],
                networks: {
                    linkedin: "",
                    facebook: "",
                    twitter: "",
                    instagram: ""
                },
                purpose: "",
                knowledgeAreas: [],
                userExperiences: [],
                professions: [],
                experience: 0
            },
            networks: [
                { title: "LinkedIn", name: "linkedin" },
                { title: "Facebook", name: "facebook" },
                { title: "Twitter", name: "twitter" },
                { title: "Instagram", name: "instagram" }
            ],
            work: {
                userId: null,
                organization: null,
                organizationName: "",
                position: "",
                brief: "",
                startAt: "",
                endAt: ""
            },
            loading: false,
            errors: [],
            resume: "",
            extensions: [Bold, Italic, Underline, Link, ListItem, BulletList, OrderedList, History],
            file: null
        };
    },

    created() {
        /// TODO se puede mejorar esta logica agregando getters en computes , para manejar dinamismo con vuex ///
        let candidate = this.$store.getters["users/getUser"];
        this.work.userId = candidate.id;
        // TODO: revisar este dispatch
        // this.$store.dispatch("organizations/search", {}).then(resp => {
        //     this.organizations = resp.organizations;
        // });

        for (let key in candidate)
            this.candidate[key] =
                key === "networks" && candidate[key] === null
                    ? this.candidate[key]
                    : candidate[key];
        if (!this.candidate.avatar) this.candidate.avatar = this.candidate.id;
        this.birthDate = this.toSlashDate;
        this.checkDate();
        if (candidate) {
            this.$v.candidate.$touch();
            this.$v.textValidate.$touch();
        }
    },

    computed: {
        ...userComputed,
        ...fixturesComputed,
        getMin() {
            let [year, month, day] = new Date()
                .toISOString()
                .substr(0, 10)
                .split("-");
            let min = new Date(parseInt(year) - 100, parseInt(month) - 1, parseInt(day))
                .toISOString()
                .substr(0, 10);
            return min;
        },
        getMax() {
            let [year, month, day] = new Date()
                .toISOString()
                .substr(0, 10)
                .split("-");
            let max = new Date(parseInt(year) - 18, parseInt(month) - 1, parseInt(day))
                .toISOString()
                .substr(0, 10);
            return max;
        },
        toSlashDate() {
            if (this.candidate.birthAt && this.candidate.birthAt.includes("-")) {
                let [year, month, day] = this.candidate.birthAt.split("-");
                return `${day}/${month}/${year}`;
            }
            return "";
        },
        candidateExperienceErrors() {
            const errors = [];
            if (!this.$v.candidate.experience.$dirty) return errors;
            !this.$v.candidate.experience.required &&
                errors.push("Años de experiencia es requerido");
            !this.$v.candidate.experience.numeric && errors.push("Debe ser solo números enteros");
            !this.$v.candidate.experience.integer && errors.push("Debe ser solo números enteros");
            return errors;
        },
        getErrorStarAtExp() {
            const errors = [];
            if (!this.$v.work.startAt.$dirty) return errors;
            !this.$v.work.startAt.required && errors.push("Fecha Obligatoria");
            return errors;
        },
        orgExpRules() {
            const errors = [];
            if (!this.$v.work.organization.$dirty) return errors;
            !this.$v.work.organization.required &&
                errors.push("El nombre de la organización es requerido");
            return errors;
        },
        positionExpRules() {
            const errors = [];
            if (!this.$v.work.position.$dirty) return errors;
            !this.$v.work.position.required && errors.push("El cargo es requerido");
            return errors;
        },
        briefExpRules() {
            const errors = [];
            if (!this.$v.work.brief.$dirty) return errors;
            !this.$v.work.brief.required && errors.push("Este campo es requerido");
            !this.$v.work.brief.maxLength &&
                errors.push("El texto debe tener como máximo 250 caracteres");
            return errors;
        },
        candidateResumeErrors() {
            const errors = [];
            if (this.getUser.resume) {
                return errors;
            }
            if (!this.$v.candidate.resume.$dirty) return errors;
            !(this.file && this.file.type === "application/pdf") &&
                errors.push("Debe ser un archivo de formato pdf");
            !this.$v.candidate.resume.required && errors.push("Curriculum Vitae Requerido");
            return errors;
        },
        candidateCountryErrors() {
            const errors = [];
            if (!this.$v.candidate.country.$dirty) return errors;
            !this.$v.candidate.country.required && errors.push("Pais requerido");
            return errors;
        },
        candidatePhoneErrors() {
            const errors = [];
            if (!this.$v.candidate.phone.$dirty) return errors;
            !this.$v.candidate.phone.numeric &&
                !this.$v.candidate.phone.integer &&
                errors.push("Solo números enteros");
            !this.$v.candidate.phone.maxLength && errors.push("Máximo 12 dígitos");
            return errors;
        },
        candidateFirstNameErrors() {
            const errors = [];
            if (!this.$v.candidate.firstName.$dirty) return errors;
            !this.$v.candidate.firstName.required && errors.push("Nombre es requerido");
            return errors;
        },
        candidateLastNameErrors() {
            const errors = [];
            if (!this.$v.candidate.lastName.$dirty) return errors;
            !this.$v.candidate.lastName.required && errors.push("Apellidos es requerido");
            return errors;
        },
        candidateCityErrors() {
            const errors = [];
            if (!this.$v.candidate.city.$dirty) return errors;
            !this.$v.candidate.city.required && errors.push("Ciudad requerida");
            return errors;
        },
        candidatePurposeErrors() {
            const errors = [];
            if (!this.$v.textValidate.purpose.$dirty) return errors;
            !this.$v.textValidate.purpose.required && errors.push("El texto es requerido");
            !this.$v.textValidate.purpose.minLength &&
                errors.push("El texto debe tener al menos 200 caracteres");
            !this.$v.textValidate.purpose.maxLength &&
                errors.push("El texto debe tener menos de 1000 caracteres");
            return errors;
        },
        candidateKnowledgeErrors() {
            const errors = [];
            if (!this.$v.candidate.knowledgeAreas.$dirty) return errors;
            !this.$v.candidate.knowledgeAreas.maxLength &&
                errors.push("Puedes seleccionar solo hasta 5 items");
            return errors;
        },
        candidateProfessionsErrors() {
            const errors = [];
            if (!this.$v.candidate.professions.$dirty) return errors;
            !this.$v.candidate.professions.required &&
                errors.push("Debe seleccionar al menos una profesión");
            return errors;
        },
        candidateDegreeErrors() {
            const errors = [];
            if (!this.$v.candidate.degree.$dirty) return errors;
            !this.$v.candidate.degree.required && errors.push("Debe seleccionar una de formación");
            return errors;
        },
        isDisabled() {
            return (
                (this.work.organizationName && this.work.organizationName) ||
                (this.work.position && this.work.position.trim().length === 0) ||
                (this.work.brief && this.work.brief.trim().length === 0) ||
                (this.work.startAt && this.work.startAt.length === 0)
            );
        },
        toDashDate() {
            if (this.birthDate && this.birthDate.includes("/")) {
                let [day, month, year] = this.birthDate.split("/");
                return `${year}-${month}-${day}`;
            }
            return "";
        }
    },

    watch: {
        "candidate.purpose"() {
            this.textValidate.purpose = this.getInnerText(this.candidate.purpose);
        },
        birthDate() {
            this.candidate.birthAt = this.toDashDate;
        }
    },

    methods: {
        checkDate() {
            let date = `${new Date()
                .toISOString()
                .substring(0, 10)} ${new Date().toLocaleTimeString()}`;

            if (!this.candidate.createdAt) {
                this.candidate.createdAt = date;
            }
            if (!this.candidate.updatedAt) {
                this.candidate.updatedAt = date;
            }
        },
        fileNameDb(value) {
            let date = new Date();
            let fileName = value
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/ /g, "_");
            return `${fileName.replace(".pdf", `-${date.getTime()}`)}.pdf`;
        },
        saveResume(e) {
            let file = e;
            if (!(file && file.name)) return;
            let form = new FormData();
            let fileName = this.fileNameDb(file.name.toString());
            this.file = file;
            this.$store
                .dispatch("uploads/getPermissions", {
                    scope: "candidate",
                    type: "curriculum",
                    resource: {
                        path: process.env.VUE_APP_ASSETS_RESUME_PATH + fileName,
                        type: file.type
                    }
                })
                .then(data => {
                    this.isLoadingFile = true;
                    for (let field in data.presignedPostData.fields) {
                        form.append(field, data.presignedPostData.fields[field]);
                    }
                    form.append("file", file);
                    this.$store
                        .dispatch("uploads/upload", {
                            form: form,
                            url: data.presignedPostData.url
                        })
                        .then(() => {
                            this.candidate.resume = fileName;
                            this.$v.candidate.resume.$touch();
                            if (this.candidateResumeErrors.length > 0) {
                                this.candidate.resume = "";
                            }
                            this.path = data.path;
                            this.isLoadingFile = false;
                        })
                        .catch(err => {
                            this.candidate.resume = "";
                            this.$v.candidate.resume.$touch();
                            console.error(err);
                            this.isLoadingFile = false;
                        });
                })
                .catch(err => {
                    this.candidate.resume = "";
                    this.$v.candidate.resume.$touch();
                    console.error(err);
                    this.isLoadingFile = false;
                });
        },
        deleteExperience(id) {
            this.expRemoveIsLoadig = true;
            this.$store
                .dispatch("users/experienceRemove", id)
                .then(() => {
                    this.candidate.userExperiences = this.candidate.userExperiences.filter(
                        experience => id !== experience.id
                    );
                })
                .catch(e => {
                    console.error(e);
                })
                .finally(() => {
                    this.expRemoveIsLoadig = false;
                });
        },
        formattDate(date) {
            const [day, month, year] = date.split("/");
            return `${year}-${month}-${day}`;
        },
        saveExperience() {
            if (this.$v.work.$invalid) {
                this.$v.work.$touch();
                return;
            }
            this.experienceIsLoadig = true;
            let experience = {
                userId: this.getUser.id,
                organizationName:
                    typeof this.work.organization === "string"
                        ? this.work.organization
                        : this.work.organization.name,
                organizationId:
                    typeof this.work.organization === "string" ? null : this.work.organization.id,
                position: this.work.position,
                brief: this.work.brief,
                startAt: this.formattDate(this.work.startAt),
                endAt: this.work.endAt === "" ? null : this.formattDate(this.work.endAt)
            };
            this.$store
                .dispatch("users/experienceUpdate", experience)
                .then(() => {
                    this.candidate.userExperiences = this.getUser.userExperiences;
                })
                .catch(e => {
                    console.error(e);
                })
                .finally(() => {
                    this.work = {
                        userId: null,
                        organization: null,
                        organizationName: "",
                        position: "",
                        brief: "",
                        startAt: "",
                        endAt: ""
                    };
                    this.$v.work.$reset();
                    this.experienceIsLoadig = false;
                });
        },
        goalsSelected(values) {
            this.candidate.goals = values;
        },
        previewForm(e) {
            this.dialog = true;
        },
        updateProfile(e) {
            this.loading = true;
            this.$store
                .dispatch("users/update", this.candidate)
                .then(() => {
                    this.finished = true;
                    this.loading = false;
                    this.$router.push({ name: "RedirectionRule" });
                })
                .catch(err => {
                    this.loading = false;
                    this.errors = err;
                });
        },
        getCV() {
            let filename = this.candidate.resume;
            let url =
                process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_RESUME_PATH + filename;
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = encodeURI(url);
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        },
        onImgLoad(evt) {
            this.dialogKey = new Date().getTime();
        }
    }
};
</script>
